// Service for the attendance-monitoring security groups catalog.
// GET /v1/catalog/monitoring/security-groups?enabled=true
// Returns the security groups the authenticated user can monitor. Shares the same
// wire shape ({ id, name }) and mapper as securityGroups/byPermission, so the
// SecurityGroupOption model and its mapper are reused rather than duplicated.

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';
import {
  mapSecurityGroupsByPermission,
  type LC_GetSecurityGroupsByPermissionOut,
  type SecurityGroupOption,
} from '@/api/domains/securityGrouping';


export class MonitoringSecurityGroupsService {
  async getEnabled(signal?: AbortSignal): Promise<ApiResponse<SecurityGroupOption[]>> {
    const endpoint =
      `${API_CONFIG.ENDPOINTS.CATALOG.MONITORING_SECURITY_GROUPS}${buildQueryString({ enabled: true })}`;

    const response = await apiClient.get<LC_GetSecurityGroupsByPermissionOut>(endpoint, { signal });

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapSecurityGroupsByPermission(response.data) };
  }
}

export const monitoringSecurityGroupsService = new MonitoringSecurityGroupsService();
